import { FaMoon, FaSun } from "react-icons/fa";
import { useTheme } from "../theme/ThemeProvider";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isDark ? "Light mode" : "Dark mode"}
      className="p-2 rounded-xl border transition
        border-slate-200 bg-slate-100 text-slate-700 hover:bg-slate-200
        dark:border-white/10 dark:bg-white/5 dark:text-slate-300 dark:hover:bg-white/10"
    >
      {isDark ? (
        <FaSun className="text-amber-400 text-sm" />
      ) : (
        <FaMoon className="text-slate-600 text-sm" />
      )}
    </button>
  );
}
